export default {
 RegisterPrivacyPolicy: {
  title: '隱私政策',
  p1: '感謝您對高盈證券有限公司（下簡稱「高盈證券」或「我們」或「我司」）的信賴和支持，我們深知個人信息對您的重要性，我們將按法律法規要求，采取相應安全保護措施，盡力保護您的個人信息安全。鑒此，高盈證券製定本《隱私政策》（下稱「本政策 /本隱私政策」）並提醒您：',
  p2: '本政策適用於高盈證券提供的產品或服務。如我們及關聯公司產品或服務中使用了高盈證券提供的產品或服務但未設獨立法律聲明及隱私權政策的，則本政策同樣適用於該部分產品或服務。',
  p3: '本政策與您使用我們的服務關系緊密，在使用我司產品和服務前，請您務必仔細閱讀本政策，在您確認充分理解並同意本政策後使用相關產品和服務。一旦您開始使用我們的各項產品或服務，即表示您已充分理解並同意本政策，並同意我們按照本政策的約定收集、使用、儲存、分享和保護您的相關信息。',
  p4: '如對本政策或相關事宜有任何問題，請通過高盈證券客服與我們聯系。',
  p5: '本政策將幫助您了解以下內容：',
  p6: '1.我們如何收集和使用您的信息',
  p7: '2.我們如何使用Cookie和同類技術',
  p8: '3.我們如何共享、轉讓、公開披露您的信息',
  p9: '4.我們如何保護您的信息',
  p10: '5.GDPR所覆蓋之個人的更多權利或信息',
  p11: '6.您的權利',
  p12: '7.我們如何保護未成年人的信息',
  p13: '8.您的信息如何在全球範圍轉移',
  p14: '9.本政策如何更新',
  p15: '10.如何聯系我們',
  p16: '一、我們如何收集和使用您的個人信息',
  p17: '在您使用我們的產品及/或服務時，我們需要/可能需要收集和使用的您的個人信息包括如下兩種：',
  p18: '為實現向您提供我們產品及/或服務的基本功能，您須授權我們收集、使用的必要的信息。如您拒絕提供相應信息，您將無法正常使用我們的產品及/或服務；',
  p19: '為實現向您提供我們產品及/或服務的附加功能，經您選擇授權我們收集、使用的信息。如您拒絕提供，您將無法正常使用相關附加功能或無法達到我們擬達到的功能效果，但並不會影響您正常使用我們產品及/或服務的基本功能。',
  p20: '您理解並同意：',
  p21: '我們致力於打造多元化的產品和服務以滿足您的需求，因我們向您提供的產品和服務種類眾多且不同用戶選擇使用的具體產品/服務範圍存在差異，相應的，基本/附加功能及收集使用的個人信息類型、範圍等會有所區別，請以具體的產品/服務功能為準；',
  p22: '為給您帶來更好的產品和服務體驗，我們在持續努力改進我們的技術，隨之我們可能會不時推出新的或優化後的功能，可能需要收集、使用新的個人信息或變更個人信息使用目的或方式。對此，我們將通過更新本政策、彈窗、頁面提示等方式另行向您說明對應信息的收集目的、範圍及使用方式，並為您提供自主選擇同意的方式，且在征得您明示同意後收集、使用。在此過程中，如果您有任何疑問、意見或建議的，您可通過上述提供的聯系方式與我們聯系，我們會盡快為您作出解答。',
  p23: '我們會實現本政策下述的各項功能，收集和使用您的個人信息：',
  p24: '(一)幫助您成為我們的用戶，以便為您提供網上服務',
  p25: '為遵守法律法規的要求，以及向您提供更個性化、更便捷的服務，當您註冊成為高盈證券用戶時，您需要至少向我們提供手機號碼或電子郵箱地址以創建帳號，並完善相關的網絡身份識別信息（如頭像、昵稱及登錄密碼等）；',
  p26: '授權登錄，為了使您可以便捷地使用第三方帳號在高盈證券註冊或登錄，我們可能會根據您的授權從第三方處獲取您的帳號信息，並與您的高盈證券帳號進行綁定，使您可以通過第三方帳號直接登錄、使用我們的產品及/或服務。我們將根據與第三方的約定，在您授權同意範圍內使用您的相關信息。',
  p27: '(二)您在使用我們服務時主動提供的信息',
  p28: '1.依據法律法規及監管規定履行反洗錢義務及進行實名製管理',
  p29: '在您申請開通帳戶時，根據法律法規及監管規定，您需要按要求提供您的身份信息，包括姓名、國籍/法定居住國、有效身份證件的種類/號碼、電子郵箱、居住地址信息、家庭情況（婚姻狀況、家庭成員個數）、出生日期、個人簽名樣式、人臉識別信息或人臉錄像信息；當您的國籍、出生地、法定居住地、納稅居住地不一致時，您還需填寫您的出生國、納稅管轄國和納稅識別號；當常住地址與身份證地址不同時，您需要另行提供地址證明文件（如含有地址信息的水電費賬單/銀行結單/駕照/房產證/戶口簿等）。',
  p30: '2.依據法律法規及監管規定履行投資適當性判斷、客戶評級和風險等級評估',
  p31: '根據法律法規要求，在您開通帳戶時我們需要對您的投資適當性進行判斷和評級，並為您提供風險等級評估，為此我們需要您提供職業狀況、資產信息（凈流動資產範圍、凈資產範圍、總資產範圍、凈年收入範圍）、投資目標和投資經驗信息（不同品種交易年限和次數、投資偏好）。當您的職業狀況為受雇或創業的時候，您需要補充詳細的職業信息，包括單位名稱、所在地區及詳細地址，公司所屬行業及從事的職位名稱。',
  p32: '3.存入/提取資金',
  p33: '當您向您的帳戶存入/提取資金時，根據風控和反洗錢要求，您需要提供您的銀行卡號碼、銀行卡持有人姓名（須與開通資金帳戶姓名一致）及存入/提取的資金金額信息。',
  p34: '4.客服',
  p35: '當您與我們聯系或提出爭議糾紛處理或辦理個人帳戶相關業務操作申請時，為了保障您的帳戶及系統安全，我們需要您提供必要的個人信息以核驗您的身份。',
  p36: '為便於與您聯系、盡快幫助您解決問題或記錄相關問題的處理方案及結果，我們可能會保存您與我們的通信/通話記錄及相關內容（包括帳號信息、訂單信息、您為了證明相關事實提供的其他信息，或您留下的聯系方式信息），如果您針對具體訂單進行咨詢、投訴或提供建議的，我們會使用您的帳號信息和訂單信息。',
  p37: '為了提供服務及改進服務質量的合理需要，我們還可能使用的您的其他信息，包括您與客服聯系時您提供的相關信息，您參與問卷調查時向我們發送的問卷答復信息。',
  p38: '(三)我們在您使用服務過程中可能收集的個人信息',
  p39: '為了滿足法律法規及提供服務的基本要求，保障您的帳號安全與系統運行安全，我們會收集您在使用我們服務過程中產生的相關信息並存儲為網絡日誌信息，包括：',
  p40: '1.設備信息',
  p41: '為了保障向您提供的服務的安全穩定和預防風險，我們需要記錄您的設備型號、唯一設備標識符、操作系統、IP地址、分辨率、應用下載渠道、當前應用版本號、應用語言設置信息。',
  p42: '2.操作日誌信息',
  p43: '當您使用軟件時，我們會收集您的使用習慣、使用時長、瀏覽偏好、頁面停留時間等操作日誌信息，以便改進產品，為您提供更好的用戶體驗。',
  p44: '(四)為您提供其他附加服務',
  p45: '為向您提供更便捷、更優質、個性化的產品及/或服務，努力提升您的體驗，我們的移動應用會向設備申請一些必要的系統權限。',
  p46_1: '基於位置信息的服務',
  p46_2: '我們會根據移動設備當前位置信息為不同國家的用戶提供更優質的行情服務。',
  p47_1: '基於相機/攝像頭的附加服務',
  p47_2: '可在開啟相機/攝像頭權限後使用該功能進行身份證及其他證件/材料拍攝、也可拍攝照片用於評價、分享，以及特定場景下經您授權的人臉識別等功能。當您使用該附加功能進行人臉識別時我們會收集您的面部特征，且嚴格在經您授權同意的範圍內使用，未來如果我們擬使用您的面部信息為您提供其他產品及/或服務功能，我們會再次與您確認。',
  p48_1: '基於相冊（圖片庫）的圖片訪問及上傳的附加服務',
  p48_2: '您在開啟相冊權限後可使用該功能上傳您的照片/圖片，以實現更換頭像、發表評論、分享、上傳身份證等證明材料。',
  p49_1: '基於麥克風的語音技術相關附加服務',
  p49_2: '您可在開啟麥克風權限後使用麥克風實現客服語音反饋服務，或與客服進行語音溝通，即使您已同意開啟麥克風權限，我們也僅會在您主動點擊客戶端內麥克風圖標或錄製視頻時通過麥克風獲取語音信息。',
  p50_1: '基於通訊錄信息的附加服務',
  p50_2: '該權限使您可以更便利地邀請您通訊錄內的聯系人在高盈證券註冊。',
  p51_1: '基於日歷的附加服務',
  p51_2: '在您授權開啟可讀取/寫入您日歷的權限後，我們將根據您的操作將您關註的公司行動的日期讀取/記入系統日歷中，以便及時為您提供提醒服務。',
  p52_1: '基於指紋、人臉識別的附加服務',
  p52_2: '我們的應用提供了指紋或人臉識別代替交易密碼保障交易安全以及進入交易、資金帳戶界面前進行指紋或人臉識別的安全附加服務，使您可以獲得更加安全的使用體驗。',
  p53_1: '基於推送的附加服務',
  p53_2: '我們的應用為您提供了產品活動、相關折扣、金融服務等的提醒及通知，使您及時獲知最新信息。',
  p54: '您理解並同意，上述附加服務中的推送服務，您可以在APP設置-推送設置中開啟或關閉，關閉權限後您將無法接收到我們推送的內容；其他附加服務可能需要您在您的設備中開啟您的位置信息 （地理位置）、攝像頭（相機）、相冊（圖片庫）、麥克風（語音）、通訊錄及/或日歷的訪問權限，以實現這些權限所涉及信息的收集和使用。您可在您的設備設置中逐項查看上述權限的狀態，並可自行決定這些權限隨時的開啟或關閉。請您註意，您開啟任一權限即代表您授權我們可以收集和使用相關個人信息來為您提供對應服務，您一旦關閉任一權限即代表您取消了授權，我們將不再基於對應權限繼續收集和使用相關個人信息，也無法為您提供該權限所對應的服務。但是，您關閉權限的決定不會影響此前基於您的授權所進行的信息收集及使用。',
  p56: '(五)為您提供安全保障',
  p57: '為提高您使用我們提供服務的安全性，保護您或其他用戶或公眾的人身財產安全免遭侵害，更好地預防釣魚網站、欺詐、網絡漏洞、計算機病毒、網絡攻擊、網絡侵入等安全風險，更準確地識別違反法律法規的情況，我們可能使用或整合您的個人信息、交易信息、設備信息、服務日誌信息以及我們關聯公司、合作夥伴取得您授權或依據法律共享的信息，來綜合識別您帳戶的風險、進行身份驗證、檢測及防範安全事件，並依法采取必要的記錄、審計、分析、處置措施。',
  p58: '(六)根據相關法律法規及國家標準，在以下情形中，我們可能會依法收集並使用您的個人信息無需征得您的授權同意:',
  p59: '1.與國家安全、國防安全直接相關的；',
  p60: '2.與公共安全、公共衛生、重大公共利益直接相關的；',
  p61: '3.與犯罪偵查、起訴、審判和判決執行等直接相關的；',
  p62: '4.出於維護您或他人的生命、財產等重大合法權益但又無法及時得到您本人同意的；',
  p63: '5.所收集的個人信息是您自行向社會公眾公開的；',
  p64: '6.從合法公開披露的信息中收集您的個人信息，例如：合法的新聞報道、政府信息公開等渠道；',
  p65: '7.根據您的要求簽訂和履行合同所必需的；',
  p66: '8.用於維護所提供的服務的安全穩定運行所必需的，例如：發現、處置服務的故障；',
  p67: '9.為合法的新聞報道所必需的；',
  p68: '10.學術研究機構基於公共利益開展統計或學術研究所必要，且對外提供學術研究或描述的結果時，對結果中所包含的個人信息進行去標識化處理的；',
  p69: '11.法律法規規定的其他情形。',
  p70: '(七)其他',
  p71: '請您理解，我們向您提供的服務是不斷更新和發展的。如您選擇使用了前述說明當中尚未涵蓋的其他服務，基於該服務我們需要收集您的信息的，我們會通過頁面提示、交互流程、協議約定的方式另行向您說明信息收集的範圍與目的，並征得您的同意。我們會按照本政策以及相應的用戶協議約定使用、存儲、對外提供及保護您的信息；如您選擇不提供前述信息，您可能無法使用某項或某部分服務，但不影響您使用我們提供的其他服務。',
  p72: '二、我們如何共享、轉讓、公開披露您的信息',
  p73: '(一)共享',
  p74: '1.業務協助',
  p75: '我們承諾對您的信息進行嚴格保密。除法律法規及監管部門另有規定外，我們僅在以下情形中與第三方共享您的信息，第三方包括我們的關聯公司、合作的金融機構以及其他合作夥伴。如果為了向您提供服務而需要將您的信息共享至第三方，我們將評估該第三方收集信息的合法性、正當性、必要性。我們將要求第三方對您的信息采取保護措施，並且嚴格遵守相關法律法規與監管要求。另外，我們會按照法律法規及國家標準的要求以確認協議、具體場景下的文案確認、彈窗提示等形式征得您的同意，或確認第三方已經征得您的同意。',
  p76: '（1）某些產品或服務可能由第三方提供或由我們與第三方共同提供，因此，我們需要向我們合作的第三方（包括清算機構和交易所）提交您的身份信息、聯系信息、職業信息、資產信息、投資信息及訂單信息後，才能提供您需要的產品或服務；',
  p77: '（2） 在事先獲得您明確同意的情況下，我們會在法律法規允許且不違背公序良俗的範圍內，依據您的授權範圍與第三方共享您的信息。',
  p78: '2.信息驗證',
  p79: '依照法律法規的要求，為了有效識別您的身份，我們會在帳戶開立過程中向合作的第三方身份驗證供應商提供您的姓名、出生日期、性別及證件號碼信息，以便我們能夠識別您為合法、有效的客戶，為您完成帳戶開立並提供後續服務。',
  p80: '3.監管審查',
  p81: '我們的各監管機構、自治協會或有權組織（包括但不限於各交易所及政府機關）出於監督及檢查的目的，可能會要求我們提供您的帳戶信息及交易信息，以便確認我們是否履行了相應的法律義務。',
  p82: '4.客服及投訴處理',
  p83: '當您有疑問需要我們解答、投訴我們、投訴他人或被他人投訴時，為了保護您及他人的合法權益，我們可能會在第三方供應商提供的客服系統中保存您的姓名及聯系方式、投訴及溝通的相關內容，並有可能會提供給消費者權益保護部門及監管機關，以便及時解決投訴糾紛，但法律法規明確禁止提供的除外。',
  p84: '(二)轉讓',
  p85: '我們不會將您的個人信息轉讓給任何公司、組織和個人，但以下情況除外：',
  p86: '1.事先獲得您的明確同意；',
  p87: '2.根據法律法規或強製性的行政或司法要求；',
  p88: '3.在涉及資產轉讓、收購、兼並、重組或破產清算時，如涉及到個人信息轉讓，我們會向您告知有關情況，並要求新的持有您個人信息的公司、組織繼續受本政策的約束。如變更個人信息使用目的時，我們將要求該公司、組織重新取得您的明確同意。',
  p89: '(三)公開披露',
  p90: '除在公布某些中獎活動名單時會脫敏展示中獎者手機號或用戶昵稱外，原則上我們不會將您的信息進行公開披露。如確需公開披露時，我們會向您告知公開披露的目的、披露信息的類型及可能涉及的敏感信息，並征得您的明確同意。',
  p91: '(四)根據相關法律法規及政策標準，在以下情形中，我們可能會依法共享、轉讓、公開披露您的個人信息無需征得您的同意：',
  p92: '1.與國家安全、國防安全直接相關的；',
  p93: '2.與公共安全、公共衛生、重大公共利益直接相關的；',
  p94: '3.與犯罪偵查、起訴、審判和判決執行等直接相關的；',
  p95: '4.出於維護您或其他個人的生命、財產等重大合法權益但又很難得到您本人同意的；',
  p96: '5.您自行向社會公眾公開的個人信息；',
  p97: '6.從合法公開披露的信息中收集的個人信息，例如：合法的新聞報道、政府信息公開等渠道。',
  p98: '請知悉，根據適用的法律，若我們對個人信息采取技術措施和其他必要措施進行處理，使得數據接收方無法重新識別特定個人且不能復原，則此類處理後數據的共享、轉讓、公開披露無需另行向您通知並征得您的同意。',
  p99: '四、我們如何保護您的信息',
  p100: '(一)我們已采取符合業界標準、合理可行的安全防護措施保護您的信息，防止數據遭到未經授權訪問、公開披露、使用、修改、損壞或丟失。我們會采取一切合理可行的措施，保護您的個人信息。我們采取物理、技術和行政管理安全措施來降低丟失、誤用、非授權訪問、披露和更改的風險，包括但不限於傳輸層數據加密、防火墻和加密存儲、物理訪問控製以及信息訪問授權控製。我們設置了安全程序保護您的信息不會被未經授權的訪問所竊取。',
  p101: '(二)我們有行業先進的以數據為核心，圍繞數據生命周期進行的數據安全管理體系，從組織建設、製度設計、人員管理、產品技術等方面多維度提升整個系統的安全性，保障您的個人信息。',
  p102: '(三)若您是歐盟用戶，根據GDPR條款，我們除了提供系統性的個人數據保護辦法外，我們的安全部-個人信息保護專員將會作為數據保護官（DPO）全面負責您的數據保護工作。',
  p103: '(四)我們會采取一切合理可行的措施，盡力避免收集無關的個人信息，我們只會在達成本政策所述目的所需的期限內保留您的個人信息，除非需要延長保留期或受到法律的允許。',
  p104: '(五)請您知悉並理解，互聯網並非絕對安全的環境，我們強烈建議您通過安全方式、復雜可靠的密碼使用我們的產品及服務，協助我們保證您的帳號安全。如您發現自己的個人信息泄密，尤其是您的帳戶或密碼發生泄露，請您立即根據本政策中提供的聯系方式聯絡我們，以便我們采取相應措施。',
  p105: '(六)在不幸發生個人信息安全事件後，我們將按照法律法規的要求向您告知：安全事件的基本情況和可能的影響、我們已采取或將要采取的處置措施、您可自主防範和降低風險的建議、對您的補救措施等。事件相關情況我們將以郵件、信函、電話、推送通知等方式告知您，難以逐一告知每位用戶時，我們會采取合理、有效的方式發布公告。同時，我們還將按照監管部門要求，上報信息安全事件的處置情況。',
  p106: '五、GDPR所覆蓋之個人的更多權利或信息',
  p107: '如果您的個人信息被設立於歐洲經濟區（簡稱「EEA」），對於受《通用數據保護條例》（簡稱「GDPR」）保護的個人信息而言，您享有一系列與您在我司留存之個人信息相關的法律權利。該等權利包括：',
  p108: '(一)獲取有關您個人信息處理的信息並訪問您在我司留存的個人信息。請註意，某些情況下，我們有權拒絕訪問個人信息（特別是受法律法規特別保護的信息）副本的請求。',
  p109: '(二)如果您的個人信息不準確或不完整，可要求我們進行更正，但如果我們需要您提供有效身份證明文件副本，以證明您的身份信息之真實性，請您配合提供。',
  p110: '(三)在某些情況下您可要求我們刪除您的個人信息。請註意，某些情況（如基於公共利益、公共健康或科學及歷史研究等目的）下即使您要求我們刪除您的個人信息，我們也有權將其保留。',
  p111: '(四)在某些情況下就我們對您個人信息的處理提出反對，並要求我們對您個人信息的處理進行限製。同樣，在某些情況下，即使您提出反對或者要求我們限製您個人信息的處理，我們也有權拒絕您的請求。如果有其他正當法定理由，我們也有權不經過您的許可繼續使用或處理。',
  p112: '根據GDPR條款，我們除了提供系統性的個人數據保護辦法外，還會設置數據保護官（DPO）全面負責您的數據保護工作。',
  p113: '我們會評估我們收到的所有請求及投訴並及時向您提供回復。我們可能要求您提供有效的身份證明文件副本，以便我們履行安全義務並防止未授權的數據披露。若您要求訪問數據的請求顯然無根據或為超常請求。',
  p114: '對於受GDPR保護的個人信息而言，我們可能會為了特定許可用途將您的個人信息傳到EEA以外地區。我們將會確保任何該等國際傳遞都會根據GDPR或其他相關法律受到適當保護。',
  p115: '六、您的權利',
  p116: '按照中國相關的法律、法規、標準，以及其他國家、地區的通行做法，我們保障您對自己的個人信息行使以下權利：',
  p117: '(一)訪問您的個人信息',
  p118: '1.您有權訪問您的個人信息，法律法規規定的例外情況除外；',
  p119: '2.您可以通過登錄我們的應用主頁進入 「我的」頁面，點擊右上角的「設置」進入「帳號管理」與「安全設置」中訪問及更改綁定手機和郵箱等信息，在「我的」-「設置」-「安全設置」下修改登錄密碼和交易密碼等。',
  p120: '3.您可以在我們的網站和應用中查看您的交易記錄；',
  p121: '4.如果您無法訪問上述信息，可以與客服取得聯系，我們將在15個工作日內回復您的訪問請求；',
  p122: '5.如果您是歐盟用戶，根據GDPR條款，您將有權要求我們調取您的個人數據並將其轉移到其他數據控製者。',
  p123: '(二)更正您的個人信息',
  p124: '您可以通過「訪問您的個人信息」中列明的方式更正或補充個人信息。',
  p125: '如果您無法通過上述方式管理這些個人信息，您可以隨時聯系我們的客服。我們將在15個工作日內回復您的訪問請求。',
  p126: '(三)刪除您的個人信息',
  p127: '在以下情形中，您可以向我們提出刪除個人信息的請求：',
  p128: '1.如果我們處理您的個人信息行為違反法律規定；',
  p129: '2.如果我們收集和使用您的個人信息，卻未征得您的明確同意；',
  p130: '3.如果我們處理個人信息的行為嚴重違反了與您的約定條款；',
  p131: '4.如果您不再使用我們的產品或服務，或您已主動註銷帳號；',
  p132: '5.如果我們不再為您提供產品或服務；',
  p133: '6.如果您是歐盟用戶，根據GDPR條款您有權要求我們刪除您的個人數據。',
  p134: '若我們決定響應您的刪除請求，我們還將同時通知從我們獲得您的個人信息的實體，要求其及時刪除，除非法律法規另有規定，或這些實體獲得您的獨立授權。當您從我們的服務中刪除信息後，我們可能不會立即在備份系統中刪除相應的信息，但會在備份更新時刪除這些信息。',
  p135: '(四)保護您的個人信息',
  p136: '您可以通過使用復雜密碼且不向任何人透露您的登錄密碼或帳戶信息，以保護您的個人信息。一旦您泄漏了您的帳號及其密碼，可能產生對您不利的後果。如您發現您的帳號及其密碼因任何原因已經或將遭受泄泄露時，請您立即聯絡我們的客服，以便我們采取相應措施。但在我們知悉此種情況和在合理時間內采取行動前，我們對此不負任何責任。',
  p137: '當您登錄我們的網站或應用，尤其是在公共設備上登錄時，會話結束後應立即點擊「我的」-「設置」-「退出登錄」進行登出。',
  p138: '我們不對因您未能保護個人信息的私密性而導致您的個人信息被第三方訪問造成的損失承擔責任。若發現任何未經授權使用您的帳號的情況或其他安全漏洞，必須立即通知我們。您的協助將有助於我們更好的保護您的個人信息。',
  p139: '(五)改變您授權同意的範圍或撤回您的授權',
  p140: '您可以通過刪除信息、關閉設備功能等方式改變您授權我們繼續收集個人信息的範圍或撤回您的授權。您也可以通過註銷帳戶的方式，撤回我們繼續收集您個人信息的全部授權。',
  p141: '請您理解，每個業務功能需要一些基本的個人信息才能得以完成，當您撤回同意或授權後，我們無法繼續為您提供撤回同意或授權所對應的服務，也不再處理您相應的個人信息。但您撤回同意或授權的決定，不會影響此前基於您的授權而開展的個人信息處理。',
  p142: '(六)註銷您的帳號',
  p143: '您可以通過以下方式申請註銷您的帳號：',
  p144: '1.聯系我們的客服尋求幫助，協助您申請註銷您的帳號。',
  p145: '2.發送郵件到指定郵箱，並備註為「註銷帳戶」，工作人員將與您溝通進行銷戶操作。',
  p146: '在您主動註銷帳號之後，我們將停止為您提供產品或服務，根據適用法律的要求刪除您的個人信息，或使其匿名化處理。',
  p147: '(七)約束信息系統自動決策',
  p148: '在某些業務功能中，我們可能僅依據信息系統、算法等在內的非人工自動決策機製做出決定。如果這些決定顯著影響您的合法權益，您有權要求我們做出解釋，我們也將在不侵害我們商業秘密或其他用戶權益、社會公共利益的前提下提供申訴方法。',
  p149: '(八)響應您的上述請求',
  p150: '為保障安全，您可能需要提供書面請求，或以其他方式證明您的身份。我們可能會先要求您驗證自己的身份，然後再處理您的請求。我們將在15個工作日內做出答復。如您不滿意，還可以通過我們的客服發起投訴。對於您合理的請求，我們原則上不收取費用，但對多次重復、超出合理限度的請求，我們將可能拒絕或者視情收取一定成本費用。尤其是對於與您的身份不直接關聯的信息、無端重復的信息，或者需要過多技術手段（例如，需要開發新系統或從根本上改變現行慣例）、給他人合法權益帶來風險或者不切實際的請求，我們有權予以拒絕。',
  p151: '在以下情形中，按照法律法規要求，我們將有權拒絕您的請求：',
  p152: '1.與國家安全、國防安全有關的；',
  p153: '2.與公共安全、公共衛生、重大公共利益有關的；',
  p154: '3.與犯罪偵查、起訴、審判和執行判決等有關的；',
  p155: '4.有充分證據表明個人信息主體存在主觀惡意或濫用權利的；',
  p156: '5.響應您的請求將導致您或其他個人、組織的合法權益受到嚴重損害的；',
  p157: '6.涉及商業秘密的。',
  p158: '七、您的信息如何在全球範圍轉移',
  p159: '我們在中華人民共和國境內收集和產生的個人信息，將存儲在中華人民共和國境內，以下情形除外：',
  p160: '(一)適用的法律有明確規定；',
  p161: '(二)獲得您的明確授權；',
  p162: '(三)您直接通過互聯網獲取跨境服務等個人主動行為。',
  p163: '針對以上情形，我們會確保依據本政策對您的個人信息提供足夠的保護。',
  p164: '八、本政策如何更新',
  p165: '我們的隱私政策可能不定期更新和調整。',
  p166: '未經您明確同意，我們不會限製您按照本政策所應享有的權利。我們會在專門頁面（如應用中「我的→設置→隱私政策」）上展示最新版的隱私政策。對於重大變更，我們還會提供更為顯著的通知（包括我們會通過公示的方式進行通知甚至向您提供彈窗提示）。',
  p167: '本政策所指的重大變更包括但不限於：',
  p168: '(一)我們的服務模式發生重大變化。如處理個人信息的目的、處理的個人信息類型、個人信息的使用方式等；',
  p169: '(二)我們在控製權等方面發生重大變化，如並購重組等引起的信息控製者變更等；',
  p170: '(三)個人信息共享、轉讓或公開披露的主要對象發生變化；',
  p171: '(四)您參與個人信息處理方面的權利及其行使方式發生重大變化；',
  p172: '(五)我們負責處理個人信息安全的責任部門、聯絡方式及投訴渠道發生變化；',
  p173: '(六)個人信息安全影響評估報告表明存在高風險時。',
  p174: '九、如何聯系我們',
  p175: '(一)如您對本政策或您個人信息的相關事宜有任何問題、意見或建議，撥打我們的客服電話+852-21872100與我們聯系。',
  p176: '(二)一般情況下，我們將在收到您的意見後15個工作日內回復。如果您對我們的回復不滿意，特別是如果您認為我們的個人信息處理行為損害了您的合法權益，您還可以向網信、電信、公安及工商等監管部門進行投訴或舉報。',
  p177: '(三)我司聯系地址：',
  p178: '香港尖沙咀港威大廈 6 座 31 樓 3102 室'
 }
}
